import {Injectable} from '@angular/core'
import {Observable} from 'rxjs'
import {DaneZgloszeniaZapytanie} from './types/dane-zgloszenia-zapytanie'
import {HttpClient, HttpHeaders} from '@angular/common/http'
import {Samoobsluga} from './types/samoobsluga';
import {
  PrzedmiotUbezpieczeniaDoKalkulacji
} from '../../../samoobsluga/proces-uszkodzen/majatek/dom/ekran-podsumowania/ekran-podsumowania.model';
import {ParametryKwotyDocelowej} from './types/ParametryKwotyDocelowej.interface';
import {LinkDokumentacja} from "./types/link-dokumentacja.interface";


@Injectable()
export class SamoobslugaService {

  constructor(private http: HttpClient) {
  }

  pobierzDaneZgloszenia(daneZgloszeniaZapytanie: DaneZgloszeniaZapytanie): Observable<Samoobsluga> {
    return this.http.get<Samoobsluga>(this.createInitUrl(daneZgloszeniaZapytanie.correlationId))
  }

  pobierzParametryKwotyDocelowej(correlationId: string): Observable<ParametryKwotyDocelowej> {
    return this.http.get<ParametryKwotyDocelowej>(this.createParametryKwotyDocelowejUrl(correlationId))
  }

  kalkuluj(id: string, przedmiotUbezpieczeniaDoKalkulacji: PrzedmiotUbezpieczeniaDoKalkulacji[]): any {
    const kwotaRoszczenia = przedmiotUbezpieczeniaDoKalkulacji[0].kwotaRoszczenia
    return this.http.post(this.createKalkulujUrl(), {przedmiotyUbezpieczenia: przedmiotUbezpieczeniaDoKalkulacji, correlationId: id, kwotaRoszczenia: kwotaRoszczenia})
  }

  rozpocznij(correlationId: string): Observable<any> {
    return this.http.post(this.createRozpocznijUrl(correlationId), null)
  }

  akceptuj(correlationId: string, numerKonta: string): Observable<any> {
    return this.http.post(this.createAkceptujUrl(correlationId), {numerKonta})
  }

  odrzuc(correlationId: string): Observable<any> {
    return this.http.post(this.createOdrzucUrl(correlationId), null)
  }

  odrzucZPrzyczyna(correlationId: string, kodPrzyczyny: string, dodatkowyOpis: string): Observable<any> {
    return this.http.post(this.createOdrzucZPrzyczynaUrl(correlationId), {kodPrzyczyny, dodatkowyOpis})
  }

  wymagajOgledzin(correlationId: string, kodPrzyczyny: string, dodatkowyOpis: string): Observable<any> {
    return this.http.post(this.createWymagajOgledzin(correlationId), {kodPrzyczyny, dodatkowyOpis})
  }

  kwotaUkrytaPrzedPoszkodowanym(correlationId: string): Observable<any> {
    return this.http.post(this.createKwotaUkrytaPrzedPoszkodowanym(correlationId), null)
  }

  aktualizacjaRoszczen(correlationId: string, roszczeniaPrzedmiotow: {idPrzedmiotu: number, kwotaRoszczenia: number}[]): Observable<any> {
    return this.http.post(this.createAktualizacjaRoszczen(correlationId), {roszczeniaPrzedmiotow})
  }

  odloz(correlationId: string, daneDoWysylkiLinku: { adresEmail: string | undefined, wysylkaAdresuEmail: boolean, numerTelefonu: string | undefined, wysylkaTelefonu: boolean }): Observable<any> {
    return this.http.post(this.createOdlozUrl(correlationId), daneDoWysylkiLinku);
  }

  pobierzLinkDokumentacji(correlationId: string): Observable<LinkDokumentacja> {
    return this.http.post<LinkDokumentacja>(this.createPobierzLinkDokumentacji(correlationId), null)
  }

  private createInitUrl(param: string): string {
    return `/sag/samoobsluga/${param}/`
  }

  private createParametryKwotyDocelowejUrl(correlationId: string): string {
    return this.createInitUrl(correlationId) + 'kwotaDocelowa/'
  }

  private createKalkulujUrl(): string {
    return this.createInitUrl('kalkuluj')
  }

  private createRozpocznijUrl(correlationId: string): string {
    return this.createInitUrl(correlationId) + 'wTrakcie/'
  }

  private createAkceptujUrl(correlationId: string): string {
    return this.createInitUrl(correlationId) + 'akceptuj/'
  }

  private createOdrzucUrl(correlationId: string): string {
    return this.createInitUrl(correlationId) + 'odrzuc/'
  }

  private createOdrzucZPrzyczynaUrl(correlationId: string): string {
    return this.createInitUrl(correlationId) + 'odrzucZPrzyczyna/'
  }

  private createWymagajOgledzin(correlationId: string): string {
    return this.createInitUrl(correlationId) + 'wymaganeOgledziny/'
  }

  private createKwotaUkrytaPrzedPoszkodowanym(correlationId: string): string {
    return this.createInitUrl(correlationId) + 'kwotaUkrytaPrzedPoszkodowanym/'
  }

  private createAktualizacjaRoszczen(correlationId: string): string {
    return this.createInitUrl(correlationId) + 'aktualizacjaRoszczen/'
  }

  private createOdlozUrl(correlationId: string): string {
    return this.createInitUrl(correlationId) + 'odloz/'
  }

  private createPobierzLinkDokumentacji(correlationId: string): string {
    return this.createInitUrl(correlationId) + 'link-dokumentacja/';
  }
}
